module.exports = __webpack_public_path__ + "static/media/19.8b27924c.png";